// extracted by mini-css-extract-plugin
module.exports = {"drag":"DragItem_drag__3V4k_"};